import EmailTemplateIndex from '@/Libs/Pages/Panel/Config/EmailTemplate/EmailTemplateIndex.vue'
import EmailTemplateDetail from '@/Libs/Pages/Panel/Config/EmailTemplate/EmailTemplateDetail.vue'
import GeneralDetail from '@/Libs/Pages/Panel/Config/General/GeneralDetail.vue'

export default [
    {
        name: 'email-template',
        path: '/email-template',
        component: EmailTemplateIndex,
        meta: {
            title: 'email_template.title.list',
            permission: 'config_email_template_list'
        },
    },
    {
        name: 'email-template-detail',
        path: '/email-template/detail/:id',
        component: EmailTemplateDetail,
        meta: {
            title: 'email_template.title.detail',
            permission: 'config_email_template_show'
        },
    },
    {
        name: 'config-general',
        path: '/config/general',
        component: GeneralDetail,
        meta: {
            title: 'config_general.title.detail',
            permission: 'config_general_show'
        },
    }
];